import Lang from 'src/libraries/language';
import yup from 'src/libraries/validator.library';

const FireAgencyShape = {
  name: yup.string().required(),
  rate: yup
    .number()
    .min(0, Lang.MSG_FIRE_AGENCY_RATE_ERROR)
    .transform((value) => (value === '' ? undefined : value))
    .nullable()
    .typeError(Lang.MSG_FIRE_AGENCY_RATE_BLANK),
  agencyId: yup.number(),
};

export const FireAgencySchema = yup
  .object()
  .shape({
    ...FireAgencyShape,
  })
  .defined();

export const FireAgencyListSchema = yup
  .object({
    fireAgencies: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...FireAgencyShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const FireAgencyFormSchema = yup
  .object()
  .shape({
    ...FireAgencyShape,
  })
  .defined();

export const FireAgencyResponsePayloadSchema = yup
  .object({
    fireAgencies: yup
      .object({
        agencyId: yup.number(),
        name: yup.string(),
        rate: yup.number(),
      })
      .defined(),
  })
  .defined();

export type IFireAgency = yup.InferType<typeof FireAgencySchema>;
export type IFireAgencyList = yup.InferType<typeof FireAgencyListSchema>;
export type IFireAgencyForm = yup.InferType<typeof FireAgencyFormSchema>;
